import { HubProgressBar } from './HubProgressBar';
import { ProjectDatesSection } from './ProjectDatesSection';
import { HubProject } from '@platform/client/schemas';

type HubProgressHeaderProps = {
  completed: number;
  total: number;
  includeDates: boolean;
  allowDateEdit: boolean;
  isTeam: boolean;
  project?: HubProject | null;
};

export const HubProgressHeader = ({
  completed,
  total,
  includeDates,
  allowDateEdit,
  isTeam,
  project,
}: HubProgressHeaderProps) => {
  return (
    <div className='lg:h-28 bg-white p-4 border-b border-gray-100'>
      <div className=' flex flex-col lg:flex-row justify-between lg:items-center'>
        <div className='text-lg'>Project Progress</div>
        {includeDates && project && project.startDate && project.endDate && (
          <ProjectDatesSection
            projectId={project.id}
            allowDateEdit={allowDateEdit}
            startDate={project.startDate}
            endDate={project.endDate}
            isTeam={isTeam}
          />
        )}
      </div>
      <HubProgressBar completed={completed} total={total} />
    </div>
  );
};
